import OptionalImage from '@src/components/optional-image';
import React from 'react';
import { getRecordList, isDataList } from '@src/utils/media-data';
import { observer } from 'mobx-react';
// import aos from '@src/utils/aos';
// aos.reInit();
import AgeAppropriateTips from '@src/components/age-appropriate-tips';
import LoadVideo from '@src/components/load-video';
import Link from '@src/components/link';
import Toast from '@src/components/toast';
import GiftRule from '../gift-rule';
// import AnimatedNumber from '@src/components/animated-number';
import $$tracker from '@src/tracker';

import cs from 'classnames';
import styles from './index.less';

const DOWNLOAD_UNAVAILABLE_MESSAGE = '当前客户端暂未开放，请稍后再试';
const RECHARGE_UNAVAILABLE_MESSAGE = '充值入口将于公测开启后开放，敬请期待';

/** 预约首页 */
const Home = ({ className, store }) => {
  store.use();
  const { projectConfig, openEligibilityInquiryModal, openRuleModal, openHarmonyDownloadModal } = store?.mainStore || {};
  const omniDataHome = store?.mainStore?.omniDataHome || {};
  const downLink = omniDataHome.down_link || {};
  const priority = {
    high: { fetchPriority: 'high', loading: 'eager' },
    low: { fetchPriority: 'low', loading: 'lazy' }
  };
  const sloganTemplate = ['left', 'center', 'right'].includes(omniDataHome?.template) ? omniDataHome.template : 'left';
  const showPlayControl = isDataList(omniDataHome.play_control) && omniDataHome.play_control.includes('pc');
  const handleDownloadClick = (event, downloadLink, trackClick, unavailableMessage = DOWNLOAD_UNAVAILABLE_MESSAGE) => {
    if (!downloadLink) {
      event.preventDefault();
      Toast.info(unavailableMessage);
    }
    trackClick();
  };

  /** 测试下载开放状态 */
  const reservationRender = () => {
    if (!projectConfig) return null;
    return (
      <div className={styles.reservation}>
        <div className={styles.stage}>
          {getRecordList(store.reservationStageList).map((item, index) => (
            <div className={cs(styles.stage_item, { [styles.completed]: true })} key={index}>
              <div className="prize-box">
                <OptionalImage className="prize" src={item.url} alt={item.numText} draggable={false} />
                <div className="text">{item.name}</div>
              </div>
              <div className="label">{item.numText}</div>
            </div>
          ))}
        </div>
        <div className={styles.right}>
          {projectConfig?.phone ? (
            <img className={styles.dis_btn} src={require('./images/yy-yiyuyue.png')} alt="已预约" draggable={false} />
          ) : (
            <img className={styles.btn} onClick={store.onReservation} src={require('./images/yy_ljyy.png')} alt="立即预约" draggable={false} />
          )}
          <p className={styles.text}>
            全网已有<span className={styles.num}>
              {(isDataList(store.reservedNum) ? store.reservedNum : []).map((str, key) => <span key={key}>{str}</span>)}
            </span>位玩家预约
          </p>
        </div>
      </div>
    );
  };
  /** 预下载、公测阶段共用下载矩阵 */
  const downloadMatrixRender = () => {
    return (
      <div className={styles['download-matrix']}>
        <div className={styles.qrcode} data-name="扫码下载游戏">
          {downLink.indexQrcode && <iframe src={downLink.indexQrcode} title="首页扫码下载游戏" />}
        </div>
        <div className={styles['download-column']}>
          <Link
            className={cs(styles['download-button'], styles.android)}
            onClick={event => handleDownloadClick(event, downLink.android, $$tracker.clickDownloadAndroid)}
            href={downLink.android}
            target="_blank"
            rel="noopener noreferrer"
            data-name="android下载"
            aria-label="安卓下载"
          />
          <Link
            className={cs(styles['download-button'], styles.apple)}
            onClick={event => handleDownloadClick(event, downLink.apple, $$tracker.clickDownloadIOS)}
            href={downLink.apple}
            target="_blank"
            rel="noopener noreferrer"
            data-name="ios下载"
            aria-label="苹果下载"
          />
        </div>
        <div className={styles['download-column']}>
          <button
            type="button"
            className={cs(styles['download-button'], styles.harmony)}
            onClick={() => {
              $$tracker.clickHongmengDown('首页');
              openHarmonyDownloadModal();
            }}
            data-name="harmony下载"
            aria-label="鸿蒙下载"
          />
          <Link
            className={cs(styles['download-button'], styles.pc)}
            onClick={event => handleDownloadClick(event, downLink.pc, $$tracker.clickDownloadPC)}
            href={downLink.pc}
            target="_blank"
            rel="noopener noreferrer"
            data-name="PC下载"
            aria-label="电脑端下载"
          />
        </div>
        <Link
          className={cs(styles['download-button'], styles.charge)}
          onClick={event => handleDownloadClick(event, downLink.charge, $$tracker.clickOfficialRecharge, RECHARGE_UNAVAILABLE_MESSAGE)}
          href={downLink.charge}
          target="_blank"
          rel="noopener noreferrer"
          data-name="官方充值"
          aria-label="官方充值"
        />
      </div>
    );
  };

  /** 渲染不同的阶段 */
  const stageRenderByStatus = () => {
    if (omniDataHome.game_stage_config === 'appointment') return reservationRender();
    if (['pre_download', 'beta_download'].includes(omniDataHome.game_stage_config)) return downloadMatrixRender();
    return null;
  };
  return (
    <div className={cs(styles['home-section'], { [styles.animate]: store.isActive }, className)}>
      {omniDataHome?.kv_image && <OptionalImage className={styles['img-kv']} src={omniDataHome?.kv_image} {...priority.high} alt="首页背景kv" />}
      {omniDataHome?.kv_video && <LoadVideo className={styles['video-kv']} src={omniDataHome?.kv_video} />}
      <button type="button" className={styles.qualification} onClick={openEligibilityInquiryModal} aria-label="资格与奖励查询" data-name="资格与奖励查询">
        <img src={require('./images/qualification.png')} alt="" draggable={false} />
      </button>
      <div className={styles['quick-actions']}>
        <GiftRule onClick={openRuleModal} />
      </div>
      <div className={styles['age-appropriate-tips']} data-name="适龄提示">
        <AgeAppropriateTips gameName="剑侠世界4" />
      </div>
      {showPlayControl && (
        <div className={styles['play-window']} onClick={store.openVideoPlayModal} data-name="播放窗口">
          {omniDataHome?.expansion_pack_img && <OptionalImage className={styles['play-window-img']} src={omniDataHome.expansion_pack_img} alt="播放窗口" />}
        </div>
      )}

      {omniDataHome.slogan && (
        <OptionalImage className={cs(styles.slogan, styles[`slogan-${sloganTemplate}`])} src={omniDataHome.slogan} alt="剑侠世界4-slogan" {...priority.high} />
      )}
      {omniDataHome.sub_title && <OptionalImage className={styles.sub_title} src={omniDataHome.sub_title} alt="副标题" />}

      {stageRenderByStatus()}
    </div>
  );
};

export default observer(Home);
